module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_06.54aa3bdb.jpg";